/** The diagonal brand bars behind the sign-in card. */
export default function AuthBackground() {
    return (
        <svg
            className="pointer-events-none fixed inset-0 -z-1 size-full"
            viewBox="0 0 1400 787"
            preserveAspectRatio="xMidYMid slice"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="auth-bg-fade-out" gradientUnits="userSpaceOnUse" x1="250" x2="900">
                    <stop offset="0" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0.85" />
                    <stop offset="1" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="auth-bg-fade-in-slow" gradientUnits="userSpaceOnUse" x1="580" x2="1000">
                    <stop offset="0" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0" />
                    <stop offset="1" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient id="auth-bg-fade-in-fast" gradientUnits="userSpaceOnUse" x1="580" x2="820">
                    <stop offset="0" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0" />
                    <stop offset="1" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0.72" />
                </linearGradient>
                <linearGradient id="auth-bg-fade-in-half" gradientUnits="userSpaceOnUse" x1="700" x2="1210">
                    <stop offset="0" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0" />
                    <stop offset="1" className="[stop-color:var(--color-auth-bar)]" stopOpacity="0.6" />
                </linearGradient>
                <linearGradient id="auth-bg-shade" gradientUnits="userSpaceOnUse" x1="0" x2="650">
                    <stop offset="0" className="[stop-color:var(--color-auth-field)]" />
                    <stop offset="1" className="[stop-color:var(--color-auth-field)]" stopOpacity="0" />
                </linearGradient>
                {/* Zero-mean grain: the arithmetic composite adds noise centred on the source colour, so it does not darken the bars. */}
                <filter id="auth-bg-grain" x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.75"
                        numOctaves={2}
                        seed={7}
                        stitchTiles="stitch"
                        result="noise"
                    />
                    <feColorMatrix
                        in="noise"
                        values="0.33 0.33 0.33 0 0  0.33 0.33 0.33 0 0  0.33 0.33 0.33 0 0  0 0 0 0 1"
                        result="mono"
                    />
                    <feComposite in="SourceGraphic" in2="mono" operator="arithmetic" k2={1} k3={0.1} k4={-0.05} />
                </filter>
            </defs>
            <g filter="url(#auth-bg-grain)">
                <rect x="-1000" y="-1000" width="3400" height="2800" className="fill-auth-field" />
                {/* Bars are laid out horizontally and the whole frame is turned 45°, so x runs along each bar. */}
                <g transform="translate(-393.5 393.5) rotate(-45)">
                    <rect x="-800" y="272" width="1750" height="103" fill="url(#auth-bg-fade-out)" />
                    <rect x="550" y="650" width="1850" height="275" fill="url(#auth-bg-fade-in-slow)" />
                    <rect x="550" y="1015" width="1850" height="275" fill="url(#auth-bg-fade-in-fast)" />
                    <rect x="-800" y="925" width="2010" height="90" rx="14" fill="url(#auth-bg-fade-in-half)" />
                    <rect x="-800" y="90" width="1455" height="182" rx="14" className="fill-auth-bar" />
                    <rect x="-800" y="375" width="1800" height="275" rx="14" className="fill-auth-bar" />
                    <rect x="-800" y="555" width="1450" height="95" fill="url(#auth-bg-shade)" />
                    <rect x="-800" y="760" width="1535" height="235" rx="14" className="fill-auth-bar" />
                    <rect x="-800" y="1100" width="1890" height="350" rx="14" className="fill-auth-bar" />
                </g>
            </g>
        </svg>
    );
}
